/**
 * Route for `campaign-wizard`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignWizardPage } from "../features/campaign-wizard/CampaignWizardPage";

export const campaignWizardRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-wizard",
	component: CampaignWizardPage,
});

export default campaignWizardRoute;
